module.exports = __webpack_public_path__ + "static/img/lasting_impressions_banner_3_m.0ed3a3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lasting_impressions_banner_3_m.jpg
// module id = 707
// module chunks = 1